export default {"src":"/_next/static/media/default-avatar.23797d23.svg","height":80,"width":80};